import React from 'react';

/**
 * Generic table — Production Incident / MTTR detailed views, Automation Coverage
 * epic adoption tables, Open Service Disruption / Open Support Bugs.
 *
 * Props:
 *   columns   — [{ key, label, render?: (row) => node }]
 *   rows      — array of row objects
 *   ariaLabel — accessible name for the table (e.g. the same string shown in
 *               the surrounding Panel's title) — this component is reused
 *               across every tab with different meanings, so it can't infer
 *               one on its own
 *   emptyMessage — string shown when rows.length === 0
 */
function DataTable({ columns, rows, ariaLabel, emptyMessage = 'No data for the current filters.' }) {
  if (!rows || rows.length === 0) {
    return <div className="qk-table-empty" role="status">{emptyMessage}</div>;
  }
  return (
    <div className="qk-table-wrap">
      <table className="qk-table" aria-label={ariaLabel}>
        <thead>
          <tr>{columns.map(c => <th key={c.key} scope="col">{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.key ?? i}>
              {columns.map(c => (
                <td key={c.key}>{c.render ? c.render(row) : (row[c.key] ?? '—')}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
